import React, { useState } from 'react';
import { Search, Mail, FileText, AlertCircle, HelpCircle, DollarSign,Tag, Truck,LucideCircleSlash, Wallet} from 'lucide-react';
import {Footer, Header,HelpCenter as HC} from '../components/components';





const HelpCenter = () => {
  const [searchQuery, setSearchQuery] = useState('');
  
  // FAQ data with icons
  const faqItems = [
    {
      id: 1,
      icon: <Mail className="text-orange-400" size={24} />,
      question: 'How do I change my account email?',
      answer: 'You can log in to your account and change it from your Profile > Edit Profile. Then go to the general tab to change your email.'
    },
    {
      id: 2,
      icon: <Wallet className="text-orange-400" size={24} />,
      question: 'How do I set milestone payment?',
      answer: 'Lorem ipsum dolor sit amet consectetur. Varius ac odo morbi pretium netius nulla orci montes sagittis. Sit nisi faucibus platea amet a erat. Massa facilisi tortor luctus scelerisque at suspendisse fringilla. Dolor adipiscing sapien et laceret at.'
    },
    {
      id: 3,
      icon: <LucideCircleSlash className="text-orange-400" size={24} />,
      question: 'What is your cancellation policy?',
      answer: 'Lorem ipsum dolor sit amet consectetur. Laboris ut ultrices sed felis leo aliquet faucibus ridiculas. Aenean nibh ornare nisi felis. Augue quis pretium tempus elementum tristique sed urna. Erat diam.'
    },
    {
      id: 4,
      icon: <Truck className="text-orange-400" size={24} />,
      question: 'How do I check project status?',
      answer: 'Lorem ipsum dolor sit amet consectetur. Tempor luctus pretium sed justo dui ultrices luctusut velit volutpat. Pretium feugiat odo ultrices commodo.'
    },
    {
      id: 5,
      icon: <DollarSign className="text-orange-400" size={24} />,
      question: 'What is Instant Refunds?',
      answer: 'Upon successful pickup of the return product at your doorstep, Myntra will instantly initiate the refund to your source account or chosen method of refund. Instant Refunds is not available in a few select pin codes and for all self ship returns.'
    },
    {
      id: 6,
      icon: <Tag className="text-orange-400" size={24} />,
      question: 'How do I verify my payment method?',
      answer: 'Lorem ipsum dolor sit amet consectetur. Diam urna placerat hac nunc volutpat. Enim a et ipsum urna vestibulum velit cras consectetur. Ultrices lectus blandit ipsum mortes amet. Purus in.'
    }
  ];
  
  // Filter FAQ items based on search query
  const filteredFAQs = faqItems.filter(item =>
    item.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
    item.answer.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
    <Header/>
    <HC Search={Search} searchQuery={searchQuery} setSearchQuery={setSearchQuery} filteredFAQs={filteredFAQs}/>
    <Footer/>
    </>
  );
};

export default HelpCenter;